import { FetchPolicy, useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import useCompanyUserId from 'common/hooks/useCompanyUserId/useCompanyUserId';

import {
  saveVirtualCardActivationDataFromLocalStorage,
  useVirtualCardActivationDataFromLocalStorage,
} from '../useVirtualCardActivationData';
import { GetAutomaticVirtualCardOrderInfoDocument } from './getAutomaticVirtualCardOrderInfo.gql';

export const useAutomaticVirtualCardOrder = (options?: {
  fetchPolicy: FetchPolicy;
}) => {
  const { companyProfileId } = useCompanyContext();
  const { companyUserId } = useCompanyUserId();

  const virtualCardActivationDataFromLocalStorage =
    useVirtualCardActivationDataFromLocalStorage(companyUserId);

  const { data, error, loading } = useQuery(
    GetAutomaticVirtualCardOrderInfoDocument,
    {
      fetchPolicy: options?.fetchPolicy,
      skip:
        !companyProfileId || virtualCardActivationDataFromLocalStorage !== null,
      variables: { companyProfileId: companyProfileId ?? '' },
    },
  );

  const automaticVirtualCardOrder =
    data?.viewer.companyUser.automaticVirtualCardOrder;

  if (automaticVirtualCardOrder?.isDefinitiveValue) {
    saveVirtualCardActivationDataFromLocalStorage(companyUserId, {
      shouldAutoOrderVirtualCard:
        automaticVirtualCardOrder.shouldAutoOrderVirtualCard,
    });
  }

  const shouldAutoOrderVirtualCard =
    virtualCardActivationDataFromLocalStorage ??
    automaticVirtualCardOrder?.shouldAutoOrderVirtualCard;

  const isPlanInsufficient = automaticVirtualCardOrder?.isPlanInsufficient;

  return {
    error,
    isPlanInsufficient,
    loading,
    shouldAutoOrderVirtualCard,
  };
};
